import { useState } from 'react'

import { useParams } from 'react-router'

import { useTemplate } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'

import { useQuery } from '../../common/hooks/useQuery.js'
import { T } from '../../i18n/components/T.js'

import { CreatePageModal } from './CreatePageModal.js'

export const CreatePageButton = () => {
  const [openCreateSpaceModal, setOpenCreateSpaceModal] = useState(false)
  const { templateId } = useParams<{ templateId?: string }>()
  const { collectionId } = useQuery<{ collectionId?: string }>()
  const [saveLoading, setSaveLoading] = useState(false)
  const { data: template } = useTemplate({
    variables: {
      id: templateId,
    },
    fields: 'basic',
    useQueryOptions: {
      enabled: !!templateId,
    },
  })

  if (!templateId) {
    return null
  }

  return (
    <>
      <Button
        size="md"
        loading={saveLoading}
        onClick={() => setOpenCreateSpaceModal(true)}
      >
        <T defaultMessage="Use template" id="Generics.UseTemplate" />
      </Button>
      {openCreateSpaceModal && (
        <CreatePageModal
          open
          onClose={() => setOpenCreateSpaceModal(false)}
          templateId={template.id}
          collectionId={collectionId}
          setLoading={() => setSaveLoading(true)}
        />
      )}
    </>
  )
}
